/* src/app/components/billing/claim-hierarchy/claim-hierarchy.component.css */
.chart-container {
  padding: 1rem;
  overflow-x: auto;
}
.node-box {
  padding: 0.75rem;
  border-radius: 6px;
  color: #333;
  text-align: center;
  font-size: 14px;
  min-width: 220px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.original-claim {
  background-color: #e3f2fd;
  border-left: 5px solid #2196f3;
}
.adjustment-claim {
  background-color: #fffde7;
  border-left: 5px solid #fbc02d;
}
.void-claim {
  background-color: #fce4ec;
  border-left: 5px solid #ec407a;
}
.new-claim {
  background-color: #e8f5e9;
  border-left: 5px solid #43a047;
}
.amendment {
  background-color: #ede7f6;
  border-left: 5px solid #7e57c2;
}
.default-claim {
  background-color: #f5f5f5;
  border-left: 5px solid #bdbdbd;
}
.label {
  font-weight: bold;
  margin-bottom: 0.25rem;
  font-size: 15px;
}
:host ::ng-deep .p-organizationchart .p-organizationchart-node-content {
  background: none;
  color: #3f3f46;
  padding: .5rem;
  border: none;
}
:host ::ng-deep .p-organizationchart-line-down {
  width: 2px !important;
}
.grid-2-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0rem 0.5rem;
  text-align: left;
  align-items: start;
  min-width: 300px;
}
/*# sourceMappingURL=claim-hierarchy.component-OFS4KCJ4.css.map */
